import React from 'react'
import styles from './styles'
import { withStyles, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PricingPlanCard from './pricing-plan-card'

// ----------------------------------------------------------------------

const PricingCard = props => {
  const { plans, type, handleClick, classes, loading } = props
  const data = plans.filter(item => item.labelAction === 'Current Plan')
  const length = data.length
  return (
    <>
      <Grid container className={classes.rootStyle}>
        {plans.map((card, index) => (
          <Grid
            item
            md={4}
            key={card.subscription}
            className={clsx({
              [classes.gridItemStart]: index === 0,
              [classes.gridItemCenter]: index === 1,
              [classes.gridItemEnd]: index === 2,
            })}
          >
            <PricingPlanCard
              userType={type}
              card={card}
              length={length}
              index={index}
              loading={loading}
              onClickHandler={() => handleClick(card)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default withStyles(styles)(PricingCard)
